/**
 * @desc 领用单详情
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.lendMaster.lendDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/lendDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
